import React, { useState, useRef, useContext, useEffect } from "react";
import { Box, Spacer, Stack } from "digiwash-components";
import CustomIcon from "../CustomIcon";
import { TouchableOpacity, ScrollView, Platform } from "react-native";
import ServiceTitle from "../ServiceTitle";
import ModalService from "../ModalService";
import { LoginContext } from "../../contexts/login";
import { logEvent } from "../../helpers/analytics-helper";
import { ListServicesType } from "../../types/server";
import { services_list_to_ga_item_list } from "../../helpers/ga-helper";
import { EVENT_TYPES } from "../../types/analytics-type";

const webStyles =
  Platform.OS === "web"
    ? {
        scrollViewContainer: {
          width: "100%",
        },
      }
    : {};

interface PropTypes {
  data: ListServicesType[];
}

function PopularServices(props: PropTypes) {
  let [modalVisible, setModalVisible] = useState(false);
  let [selectedService, setSelectedService] = useState(undefined);
  let { setLoginModalOpen } = useContext(LoginContext);

  let containerRef = useRef(null);

  let dismiss = () => {
    setModalVisible(false);
    setSelectedService(undefined);
  };

  useEffect(() => {
    logEvent(
      EVENT_TYPES.VIEW_ITEM_LIST,
      services_list_to_ga_item_list(
        "popular_services",
        "خدمات محبوب",
        props.data
      )
    );
  }, []);
  return (
    <>
      <ScrollView
        onContentSizeChange={() =>
          Platform.OS === "android"
            ? containerRef.current?.scrollToEnd({ animated: false })
            : null
        }
        horizontal
        contentContainerStyle={{
          flexGrow: 1,
        }}
        ref={containerRef}
        key="Scrolling"
        style={{
          ...{
            flexGrow: 1,
            direction: "rtl",
          },
          ...webStyles.scrollViewContainer,
        }}
      >
        <Stack>
          {props.data?.map((item) => {
            let displayName = item.children.map((item) => {
              return item.display_name;
            });

            return (
              <>
                <TouchableOpacity
                  onPress={() => {
                    setSelectedService(item);
                    setModalVisible(true);
                  }}
                >
                  <Box
                    style={{
                      position: "relative",
                      alignItems: "center",
                      width: 128,
                    }}
                  >
                    <ServiceTitle
                      title={item.name}
                      subtitle={displayName.join("، ")}
                    />
                    <CustomIcon icon={item.alias} width={64} height={64} />
                  </Box>
                </TouchableOpacity>
                <Spacer size="xm" />
              </>
            );
          })}
        </Stack>
      </ScrollView>
      <ModalService
        visible={modalVisible}
        dismiss={dismiss}
        selectedService={selectedService}
        onLogin={() => {
          setModalVisible(false);
          setLoginModalOpen(true);
        }}
      />
    </>
  );
}

export default PopularServices;
